export const LiquidFactoryAbi = [
  {
    type: "function",
    name: "deployToken",
    inputs: [
      {
        name: "deploymentConfig",
        type: "tuple",
        components: [
          {
            name: "tokenConfig",
            type: "tuple",
            components: [
              { name: "tokenAdmin", type: "address" },
              { name: "name", type: "string" },
              { name: "symbol", type: "string" },
              { name: "salt", type: "bytes32" },
              { name: "image", type: "string" },
              { name: "metadata", type: "string" },
              { name: "context", type: "string" },
              { name: "originatingChainId", type: "uint256" },
            ],
          },
          {
            name: "poolConfig",
            type: "tuple",
            components: [
              { name: "hook", type: "address" },
              { name: "pairedToken", type: "address" },
              { name: "tickIfToken0IsLiquid", type: "int24" },
              { name: "tickSpacing", type: "int24" },
              { name: "poolData", type: "bytes" },
            ],
          },
          {
            name: "lockerConfig",
            type: "tuple",
            components: [
              { name: "locker", type: "address" },
              { name: "rewardAdmins", type: "address[]" },
              { name: "rewardRecipients", type: "address[]" },
              { name: "rewardBps", type: "uint16[]" },
              { name: "tickLower", type: "int24[]" },
              { name: "tickUpper", type: "int24[]" },
              { name: "positionBps", type: "uint16[]" },
              { name: "lockerData", type: "bytes" },
            ],
          },
          {
            name: "mevModuleConfig",
            type: "tuple",
            components: [
              { name: "mevModule", type: "address" },
              { name: "mevModuleData", type: "bytes" },
            ],
          },
          {
            name: "extensionConfigs",
            type: "tuple[]",
            components: [
              { name: "extension", type: "address" },
              { name: "msgValue", type: "uint256" },
              { name: "extensionBps", type: "uint16" },
              { name: "extensionData", type: "bytes" },
            ],
          },
        ],
      },
    ],
    outputs: [{ name: "tokenAddress", type: "address" }],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "tokenDeploymentInfo",
    inputs: [{ name: "token", type: "address" }],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          { name: "token", type: "address" },
          { name: "hook", type: "address" },
          { name: "locker", type: "address" },
          { name: "extensions", type: "address[]" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "deploymentInfoForToken",
    inputs: [{ name: "token", type: "address" }],
    outputs: [
      { name: "token", type: "address" },
      { name: "hook", type: "address" },
      { name: "locker", type: "address" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "deprecated",
    inputs: [],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "TOKEN_SUPPLY",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "BPS",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "teamFeeRecipient",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "enabledLockers",
    inputs: [
      { name: "locker", type: "address" },
      { name: "hook", type: "address" },
    ],
    outputs: [{ name: "enabled", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "event",
    name: "TokenCreated",
    inputs: [
      { name: "msgSender", type: "address", indexed: false },
      { name: "tokenAddress", type: "address", indexed: true },
      { name: "tokenAdmin", type: "address", indexed: true },
      { name: "tokenImage", type: "string", indexed: false },
      { name: "tokenName", type: "string", indexed: false },
      { name: "tokenSymbol", type: "string", indexed: false },
      { name: "tokenMetadata", type: "string", indexed: false },
      { name: "tokenContext", type: "string", indexed: false },
      { name: "startingTick", type: "int24", indexed: false },
      { name: "poolHook", type: "address", indexed: false },
      { name: "poolId", type: "bytes32", indexed: false },
      { name: "pairedToken", type: "address", indexed: false },
      { name: "locker", type: "address", indexed: false },
      { name: "mevModule", type: "address", indexed: false },
      { name: "extensionsSupply", type: "uint256", indexed: false },
      { name: "extensions", type: "address[]", indexed: false },
    ],
    anonymous: false,
  },
] as const;
